var _style, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuscar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.73 141.73",
    style: {
      enableBackground: "new 0 0 141.73 141.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000155833090924157819700000018379479235877030828_);}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.8239,
    y1: -598.5063,
    x2: 71.8239,
    y2: -540.5073,
    gradientTransform: "matrix(-1 0 0 -1 142.9291 -498.5594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00356F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007BC2"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.47,41.95h91.28c3.29,0,5.96,2.67,5.96,5.96v46.07c0,3.29-2.67,5.96-5.96,5.96H25.47 c-3.29,0-5.96-2.67-5.96-5.96V47.91C19.5,44.62,22.17,41.95,25.47,41.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133519388187953446150000004562987764058796422_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.1053,
    y1: 43.9479,
    x2: 71.1053,
    y2: 97.9469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00356F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007BC2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133519388187953446150000004562987764058796422_)"
    },
    d: "M114.75,97.95H27.47 c-3.29,0-5.96-2.67-5.96-5.96V49.91c0-3.29,2.67-5.96,5.96-5.96h87.28c3.29,0,5.96,2.67,5.96,5.96v42.07 C120.71,95.28,118.04,97.95,114.75,97.95z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.28,77.85h6.46c4.24,0,5.62,1.75,5.62,3.73s-1.31,3.44-3.49,3.98c1.38,0.49,2.36,1.51,2.36,3.11 c0,2.69-2.24,4.73-7.07,4.73H32.1L36.28,77.85z M40.5,89.94c1.49,0,2.4-0.67,2.4-1.64c0-0.8-0.64-1.22-1.91-1.22h-2.98l-0.78,2.87 H40.5z M41.74,84.05c1.53,0,2.36-0.6,2.36-1.58c0-0.71-0.56-1.16-1.87-1.16h-2.69l-0.71,2.73H41.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.81,90.07c0-0.64,0.13-1.4,0.33-2.16l1.75-6.53h4.22l-1.69,6.29c-0.09,0.31-0.16,0.71-0.16,0.98 c0,0.8,0.47,1.27,1.36,1.27c1.18,0,1.87-0.8,2.22-2.18l1.71-6.35h4.22l-3.2,12.02h-4.22l0.36-1.38c-0.82,0.87-2,1.64-3.42,1.64 C50.12,93.67,48.81,92.27,48.81,90.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.44,91.6l2.09-2.47c1.16,1.04,2.78,1.62,4,1.62c0.71,0,1.07-0.29,1.07-0.73c0-0.42-0.47-0.67-1.64-1.13 c-1.91-0.76-3.38-1.6-3.38-3.51c0-2.4,1.93-4.27,5.24-4.27c2.18,0,4.11,0.8,5.2,1.69L72,85.34c-1.04-0.78-2.31-1.29-3.4-1.29 c-0.69,0-1.04,0.27-1.04,0.69c0,0.4,0.42,0.64,1.67,1.13c1.73,0.69,3.35,1.51,3.35,3.51c0,2.31-1.73,4.31-5.2,4.31 C65.09,93.69,62.89,92.89,61.44,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.24,88.43c0-4.04,3.22-7.29,7.22-7.29c2.8,0,4.47,1.44,5.11,3.29l-3.31,1.71 c-0.4-0.93-0.98-1.51-2.07-1.51c-1.6,0-2.89,1.75-2.89,3.58c0,1.22,0.8,2,1.84,2c0.89,0,1.53-0.38,2.27-1.11l2.58,2.24 c-1.22,1.42-2.73,2.36-5.13,2.36C76.61,93.69,74.24,91.67,74.24,88.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.03,90.38c0-2.64,2.11-4.24,5.29-4.24c1.09,0,2.09,0.18,3.04,0.47l0.04-0.16c0.04-0.2,0.11-0.44,0.11-0.73 c0-0.78-0.6-1.29-2.07-1.29c-1.13,0-2.4,0.27-3.24,0.6l-0.6-3.07c1.27-0.44,3-0.73,4.73-0.73c3.6,0,5.35,1.42,5.35,3.82 c0,0.56-0.09,1.13-0.24,1.73l-1.78,6.62h-4.15l0.33-1.29c-1.02,0.96-2.07,1.53-3.47,1.53C87.41,93.65,86.03,92.38,86.03,90.38z  M93.81,88.87l0.11-0.4c-0.47-0.16-1-0.27-1.58-0.27c-1.33,0-2.2,0.64-2.2,1.73c0,0.69,0.49,1.11,1.2,1.11 C92.43,91.05,93.47,90.09,93.81,88.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.02,81.38h4.22l-0.64,2.42c1.16-1.71,2.55-2.75,4.51-2.62l-1.2,4.44h-0.36c-2.31,0-3.8,1.29-4.55,4.15 l-0.98,3.62H98.8L102.02,81.38z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.21,75.2l-3.07-3.07c-0.38-0.38-0.38-1,0-1.38l8.06-8.06c0.38-0.38,1-0.38,1.38,0l3.07,3.07 c0.38,0.38,0.38,1,0,1.38L61.6,75.2C61.21,75.58,60.59,75.58,60.21,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.56,49.78c-3.72-3.72-9.75-3.72-13.47,0s-3.72,9.75,0,13.47c3.72,3.72,9.75,3.72,13.47,0 C86.29,59.53,86.29,53.5,82.56,49.78z M71.04,61.3c-2.64-2.64-2.64-6.93,0-9.57c2.64-2.64,6.93-2.64,9.57,0 c2.64,2.64,2.64,6.93,0,9.57C77.97,63.94,73.69,63.94,71.04,61.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscar);
export default __webpack_public_path__ + "static/media/Buscar.73ff417df4cedf987d3d6f0bc1f26706.svg";
export { ForwardRef as ReactComponent };